// extracted by mini-css-extract-plugin
module.exports = {"alignRight":"alignRight___SL9jg"};